import { Button } from "@shared/ui/button";
import { 
  Plus,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { OutstandingSummary } from "../summary";
import { OutstandingCurrentList } from "../list";

const OutstandingLandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="page-title">Outstanding Accounts</h1>
          <p className="page-subtitle">Manage and analyze outstanding account balances and collection activities.</p>
        </div>
      </div>

      <OutstandingSummary />

      <OutstandingCurrentList />
    </div>
  );
};

export default OutstandingLandingPage;
